/**
 * focus-route — کدام مسیر «حالتِ کانونیِ full-bleed» می‌گیرد (S-LIVE-P0 §۴٫۱٫۱)
 * ---------------------------------------------------------------------------
 *   /live-class                 → فهرستِ جلسه‌ها (صفحهٔ کاریِ معمولی)
 *   /live-class/:sessionId/lobby → پیش‌اتاق      ← کانونی
 *   /live-class/:sessionId       → اتاقِ کلاس     ← کانونی
 *   /live-class/:sessionId/report → گزارشِ پس از جلسه (صفحهٔ کاریِ معمولی)
 *   /live-class/admin           → سقفِ ظرفیت — مسیرِ ایستا (صفحهٔ کاریِ معمولی)
 *
 * S-MODALSHELL قدمِ صفر — رگرسیونِ کشف‌شده: نسخهٔ قبلی این تابع یک رشتهٔ خام
 * (پارامترِ حاصل از شکافتنِ URL) می‌گرفت، پس هر بخشِ دومِ `/live-class/*` را
 * «شناسهٔ نشست» فرض می‌کرد — از‌جمله `admin` که در واقع یک مسیرِ ایستای همسایه
 * است نه پارامتر. نتیجه: `/live-class/admin` بدونِ ناو/ریل/بردکرامب رندر
 * می‌شد. حالا فراخوان باید `hasSessionId` را از تطبیقِ واقعیِ react-router
 * (پارامترِ منطبق‌شده، نه شکافتنِ رشته) بدهد — که برایِ یک مسیرِ ایستا مثلِ
 * admin ذاتاً false است، فارغ از اینکه در URL چه رشته‌ای نشسته باشد.
 */
export const isLiveFocusRoute = (
  route: string,
  hasSessionId: boolean,
  isReportPath = false,
): boolean => {
  if (route !== "live-class") return false;
  if (!hasSessionId) return false;
  return !isReportPath;
};
